import React, { useEffect, useState } from 'react';
import { ForkKnife } from '@phosphor-icons/react';
import client from '../api/client';
import AppIcon from './AppIcon';

const BAR = { Meat: '#B4235A', Fish: '#0284C7', Vegetarian: '#2E7D32', Vegan: '#0D9488', Kids: '#D97706' };

export const MealSummaryCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { client.get('/meals/summary').then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  const max = Math.max(1, ...d.meals.map((m) => m.count), d.notChosen);
  return (
    <div data-testid="meal-summary-card" className="soft-card rounded-2xl p-6 bg-white border border-[#EFE3D8]">
      <div className="flex items-center gap-3 mb-4">
        <AppIcon icon={ForkKnife} tone="coral" size="md" reveal delay={200} />
        <div>
          <h3 className="font-serif text-xl text-[#2A2A2A]">Meals & dietary notes</h3>
          <p className="text-xs text-[#6A6A6A]">{d.totalPlates} plate{d.totalPlates === 1 ? '' : 's'} for attending guests and plus-ones</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <ul className="space-y-2">
          {[...d.meals, ...(d.notChosen ? [{ meal: 'Not chosen yet', count: d.notChosen }] : [])].map((m) => (
            <li key={m.meal} data-testid={`meal-count-${m.meal.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className="flex justify-between text-sm"><span className="text-[#2A2A2A]">{m.meal}</span><span className="font-serif">{m.count}</span></div>
              <div className="h-1.5 rounded-full bg-[#F4E4DA] mt-1 overflow-hidden">
                <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${(m.count / max) * 100}%`, background: BAR[m.meal] || '#9A8A7E' }} />
              </div>
            </li>
          ))}
          {!d.meals.length && !d.notChosen && <li className="text-sm text-[#9A8A7E]">No attending guests yet.</li>}
        </ul>
        <div>
          <p className="text-[10px] uppercase tracking-wider text-[#7B2C3B] mb-2">Dietary notes ({d.dietaryNotes.length})</p>
          <ul data-testid="meal-dietary-notes" className="space-y-1.5 max-h-40 overflow-auto text-sm">
            {d.dietaryNotes.map((n) => <li key={n.guestId}><strong className="font-medium">{n.name}</strong>: <span className="text-[#4A4A4A]">{n.note}</span></li>)}
            {!d.dietaryNotes.length && <li className="text-[#9A8A7E]">No dietary notes yet.</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MealSummaryCard;
